import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {AddClassCodesToSelectionAction} from "mindsets-js-sdk";

const Results = function ({lessons, setLessons, setSelectedLessonCodesString, schedule}) {
    const dispatch = useDispatch();
    const selected_lesson_codes = useSelector(state => state.selected_lesson_codes);
    const renderAction = function () {
        let is_all_valid = true;
        Object.keys(lessons).map(lesson_code => {
            if (!lessons[lesson_code].is_valid) {
                is_all_valid = false;
            }
        });
        if (is_all_valid) {
            return (
                <button onClick={event => {
                    event.preventDefault();
                    schedule();
                }}>Schedule all classes for grading</button>
            );
        } else {
            return (
                <button onClick={event => {
                    event.preventDefault();
                    let selected_lesson_codes_new = JSON.parse(JSON.stringify(selected_lesson_codes));
                    Object.keys(lessons).map(lesson_code => {
                        if (lessons[lesson_code].is_valid === false) {
                            selected_lesson_codes_new.splice(
                                selected_lesson_codes_new.findIndex(selected_lesson_code => selected_lesson_code === lesson_code),
                                1
                            );
                        }
                    });
                    setLessons({});
                    setSelectedLessonCodesString(selected_lesson_codes_new.join(', '));
                    dispatch(AddClassCodesToSelectionAction(selected_lesson_codes_new));
                }}>Remove failed classes from selection</button>
            );
        }
    }
    if (Object.keys(lessons).length) {
        return (
            <div>
                <h4>Verification results</h4>
                {Object.keys(lessons).map(lesson_code => {
                    return (
                        <div key={lesson_code} className='d-flex flex-box-0-5'>
                            <i className={'fas ' + (lessons[lesson_code].is_valid ? 'fa-check green' : 'fa-times red')}/>
                            <div>
                                {lessons[lesson_code].is_valid ?
                                    <div>{lesson_code.toUpperCase()} passed verification</div> :
                                    <div>{lesson_code.toUpperCase()} verification failed</div>}
                                <ul>
                                    <li>Teacher: {lessons[lesson_code].owner_name}</li>
                                    <li>School: {lessons[lesson_code].school_name}</li>
                                    <li>District: {lessons[lesson_code].district_name}</li>
                                    <li>Challenge: {lessons[lesson_code].challenge_name}</li>
                                    {lessons[lesson_code].messages.map((message, index) => {
                                        return (
                                            <li key={index}>{message}</li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    );
                })}
                {renderAction()}
            </div>
        );
    }

    return null;
}

Results.propTypes = {
    lessons: PropTypes.object.isRequired,
    setLessons: PropTypes.func.isRequired,
    setSelectedLessonCodesString: PropTypes.func.isRequired,
    schedule: PropTypes.func.isRequired
}

export default Results;
